const createQuery = () => `
  ... on CompanyForm {
    id
    formCraftId
  }
`

export default createQuery
